import { Spin, Row, Col } from 'antd';
import React from 'react';

const Spinner = () => (
  <Spin size="large" style={{ width: '100%', marginTop: '20vh' }} />
);

export default Spinner;
